export const scrollToTop = () => {
  try {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  } catch (err) {
    // This error can be ignored silently.
    // Some old browsers do not support scrollTo.
  }
};
